module.exports = __webpack_public_path__ + "static/Falabella_giftcard-d0146ea934818941f8daf4b7c0ec5c15.png";